import { useTheme } from '../../context/ThemeContext';

const THEMES = [
  { value: 'light', label: 'Light' },
  { value: 'auto',  label: 'Auto'  },
  { value: 'dark',  label: 'Dark'  },
];

function PreviewWindow({ mode }) {
  const isLight = mode === 'light';
  const isAuto  = mode === 'auto';

  const bgStyle = isAuto
    ? { background: 'linear-gradient(90deg, #FAFAF8 50%, #121214 50%)' }
    : isLight
      ? { background: '#FAFAF8' }
      : { background: '#121214' };

  const lineOpacity = isLight ? 0.3 : 0.2;

  return (
    <div className="preview-window" style={bgStyle}>
      <div className="pv-pill" style={{ background: `rgba(128,128,128,${isLight ? 0.2 : 0.1})` }}></div>
      <div className="pv-lines">
        <div className="pv-line w1" style={{ background: `rgba(128,128,128,${lineOpacity + 0.1})` }}></div>
        <div className="pv-line w2" style={{ background: `rgba(128,128,128,${lineOpacity})` }}></div>
      </div>
      <div className="pv-box" style={{ background: `rgba(128,128,128,${isLight ? 0.1 : 0.05})` }}>
        <div className="pv-dot"></div>
      </div>
    </div>
  );
}

export default function ThemeSelector({ onChange }) {
  const { themeMode, setThemeMode } = useTheme();

  function handleSelect(value) {
    setThemeMode(value);
    onChange?.(value);
  }

  return (
    <div className="theme-selector-grid">
      {THEMES.map(({ value, label }) => (
        <div
          key={value}
          className={`theme-card ${themeMode === value ? 'active' : ''}`}
          onClick={() => handleSelect(value)}
        >
          <div className="theme-preview">
            <PreviewWindow mode={value} />
          </div>
          <span className="theme-label">{label}</span>
        </div>
      ))}
    </div>
  );
}
